module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.81e08a9d.svg";